import { useQuery, UseQueryOptions, UseQueryResult } from "@tanstack/react-query";
import { PROPERTY_OWNERSHIP_V2_API } from "../apiRoutes";
import axiosAuth from "@/services/axiosAuth";

interface UseGetOwnershipGridProps {
  communityId: string;
  data: any;
  queryParams?: Omit<UseQueryOptions, "queryKey">;
}

const getOwnershipGrid = async (communityId: string, data: any) =>
  await axiosAuth.post(`${PROPERTY_OWNERSHIP_V2_API(communityId)}/grid`, data);

/** People -> Property Ownership grid (one row per ownership). */
const useGetOwnershipGrid = ({ communityId, data, queryParams }: UseGetOwnershipGridProps): UseQueryResult<any> => {
  return useQuery({
    queryKey: ["ownership-grid", communityId, data],
    queryFn: () => getOwnershipGrid(communityId, data),
    select: (data: any) => data.data,
    refetchOnWindowFocus: false,
    ...queryParams,
    enabled: !!communityId && communityId != "all" && (queryParams?.enabled ?? true),
  });
};

export default useGetOwnershipGrid;
